import request from "@/utils/request";
// 学习打卡

// 获取学习打卡模块列表
export function getModuleList(where) {
    return request.get("/business/study", where);
}

// pc-查询学习打卡模块列表
export function getModuleListPC(where) {
    return request.get("/business/study/pcBStudy", where);
}

// 获取学习打卡的课程列表
export function getStudyCourseList(where) {
    return request.get("/business/study/detail", where);
}

// 获取学习打卡的课程详情
export function getStudyCourseDetail(where) {
    return request.get("/business/study/detail/info", where);
}

// 更新学习课程的状态
export function setStudyCourseStatus(where) {
    return request.get("/business/study/detail/after", where);
}
